import { render, staticRenderFns } from "./sfx-fold.vue?vue&type=template&id=f730ba0e&scoped=true&"
import script from "./sfx-fold.vue?vue&type=script&lang=js&"
export * from "./sfx-fold.vue?vue&type=script&lang=js&"
import style0 from "./sfx-fold.vue?vue&type=style&index=0&id=f730ba0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f730ba0e",
  null
  
)

export default component.exports